module.exports = __webpack_public_path__ + "static/img/zhuangshi02.7fe1dc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhuangshi02.png
// module id = YpNv
// module chunks = 60